interface LocalizedContent {
  localeSlugs?: Record<string, string> | null;
  slug?: string | null;
}

const LOCALE_PREFIX_RE = /^\/[a-z]{2}(?=\/)/;

export function localizedContentPath(
  pathname: string,
  targetLocale: string,
  content?: LocalizedContent | null
) {
  const targetSlug = content?.localeSlugs?.[targetLocale];

  if (!(content?.slug && targetSlug)) {
    return pathname;
  }

  const pathWithoutLocale = pathname.replace(LOCALE_PREFIX_RE, "");

  if (pathWithoutLocale.startsWith("/blog/")) {
    return `/blog/${targetSlug}`;
  }

  if (pathWithoutLocale.startsWith("/projects/")) {
    return `/projects/${targetSlug}`;
  }

  return pathname;
}
